import Cross from 'public/cross.svg';
import type { NextBestActionCardComponentProps } from 'src/app/types';

import { CloseButtonWrap, CloseCardButton, NBACapsuleCard } from '../../styles';

import { HeaderText, HeaderTextRow, Image, ImageRow, Text, TextRow, TextTop } from './styles';

const AnyDrAnyMedNBACard = ({
  handleCardClick,
  isDismissing,
  handleCloseCardClick,
}: NextBestActionCardComponentProps) => (
  <NBACapsuleCard className="styled-card" onClick={handleCardClick} isDismissing={isDismissing} color={'white'}>
    <HeaderTextRow>
      <HeaderText variant="small">DID YOU KNOW</HeaderText>
      <CloseButtonWrap onClick={handleCloseCardClick}>
        <CloseCardButton src={Cross} />
      </CloseButtonWrap>
    </HeaderTextRow>
    <ImageRow>
      <Image src={'/public/any-dr-any-med-nba.jpg'} />
    </ImageRow>
    <TextRow>
      <TextTop variant="h3">Going to the doctor?</TextTop>
      <Text variant="body">Capsule is for all doctors and all medications.</Text>
    </TextRow>
  </NBACapsuleCard>
);

export default AnyDrAnyMedNBACard;
